import styled from 'styled-components';

export const StyledContainerActivityInfo = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	width: 1100px;
	height: 100%;
	padding: 0 5px;
	box-sizing: border-box;
	margin-top: 20px;
	user-select: text;
`;

export const StyledContainerActivityDetails = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	width: 1100px;
	height: 100%;
	padding: 0 5px;
	box-sizing: border-box;
	margin-top: 20px;
`;
export const StyledTextValue = styled.div`
	width: 100%;
	font-size: 14px;
	color: rgb(2, 62, 138);
	overflow: auto;
`;
export const StyledLeftPanel = styled.div`
	flex-direction: column;
	align-items: center;
	justify-content: center;
	width: 550px;
	height: 100%;
	padding: 0 5px;
	box-sizing: border-box;
	margin-top: 10px;
`;

export const StyledRightPanel = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: start;
	width: 550px;
	height: 100%;
	padding: 0 15px;
	box-sizing: border-box;
	margin-top: 10px;
`;

export const StyledRow = styled.span`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: flex-start;
	width: 100%;
	@media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
		span {
			font-size: 12px;
		}
		.CircleButtonPhone {
			right: 20px;
			margin-top: -50px;
			width: 35px;
			height: 35px;
		}
	}
`;

export const StyledRowPrimary = styled(StyledRow)`
	color: ${({ theme }) => theme.colors.primary};
	margin-bottom: 10px;
`;

export const StyledHeader = styled.div`
	margin-top: 10px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: flex-start;
	width: 100%;
`;

export const StyledHeaderComment = styled.div`
	margin-top: 80px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: flex-start;
	width: 100%;
`;

export const StyledHeaderTitle = styled.h5`
	font-size: 16px;
	font-weight: 600;
	margin: 0;
	@media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
		font-size: 13px;
	}
`;

export const StyledCommentContainer = styled.div`
	font-size: 16px;
	font-weight: 600;
	margin: 0;
	position: relative;
	padding-bottom: 20px;
`;

export const StyledContainer = styled.div`
	h2 {
		text-align: center;
	}
	width: 95%;
	margin: auto;
	padding: 32px;
`;
export const StyledBlock = styled.span`
	width: 100%;
	display: inline-block;
	position: relative;
	text-align: center;
`;
export const StyledBlockIconComment = styled.span`
	position: absolute;
	right: 28px;
	top: 14px;
`;
export const StyledBlockComment = styled.div`
	position: absolute;
	margin-top: 100px;
	font-size: 12px;
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
`;

export const StyledError = styled.div`
	color: #721c24;
	background-color: #f8d7da;
	border-color: #f5c6cb;
	padding: 0.75rem 1.25rem;
	margin-bottom: 1rem;
	border: 1px solid transparent;
	border-radius: 0.25rem;
`;

export const StyledTextAreaComment = styled.div`
	width: 100%;
	height: 100px;
	overflow-y: scroll;
	color: rgb(30, 41, 59);
	padding: 12px;
	border: 1px solid rgb(237, 242, 247);
	font-size: 13px;
	line-height: 24px;
	resize: none;
	background-color: #f9f9f9;
	border-radius: 4px;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

	&::-webkit-scrollbar {
		width: 10px;
	}

	&::-webkit-scrollbar-track {
		background: #f1f1f1;
	}

	&::-webkit-scrollbar-thumb {
		background-color: ${({ theme }) => theme.colors.primary};
		border-radius: 10px;
		border: 2px solid #f1f1f1;
	}

	&::-webkit-scrollbar-thumb:hover {
		background-color: ${({ theme }) => theme.colors.primaryLight};
	}

	@media (max-width: ${({ theme }) => theme.breakpoints.md}) {
		width: 100%;
		max-width: 100%;
		height: 20vh;
		font-size: 14px;
	}

	@media (max-width: ${({ theme }) => theme.breakpoints.md}) {
		height: 8vh;
		font-size: 11px;
	}
	cursor: pointer;
`;

export const StyledFieldsetContainer = styled.div`
	width: 75%;
	border-radius: 4px;
	padding: 20px;
	margin-top: 50px;
	box-shadow: 0 0 5px ${({ theme }) => theme.colors.primary};
	@media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
		padding: 10px;
		width: 71%;
		box-shadow: 0 0 0;
		background-color: ${({ theme }) => theme.colors.grey};
		cursor: pointer;
		margin-top: 0px;
	}
	@media (max-width: ${({ theme }) => theme.breakpoints.xs}) {
		margin-top: 0px;
		width: 60%;
		margin-top: 0px;
	}
`;

export const StyledTextArea = styled.textarea`
	width: 100%;
	height: 120px;
	overflow-y: scroll;
	color: rgb(30, 41, 59);
	padding: 12px;
	border: 2px solid ${({ theme }) => theme.colors.primaryLight};
	font-size: 13px;
	line-height: 24px;
	resize: none;
	background-color: #f9f9f9;
	border-radius: 4px;
	&:focus {
		border-color: ${({ theme }) => theme.colors.primary};
		outline: none;
	}
	&::-webkit-scrollbar {
		width: 10px;
	}

	&::-webkit-scrollbar-track {
		background: #f1f1f1;
	}

	&::-webkit-scrollbar-thumb {
		background-color: ${({ theme }) => theme.colors.primary};
		border-radius: 10px;
		border: 2px solid #f1f1f1;
	}

	&::-webkit-scrollbar-thumb:hover {
		background-color: ${({ theme }) => theme.colors.primaryLight};
	}
	&::-webkit-scrollbar {
		display: block;
	}
	@media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
		width: 100%;
		max-width: 100%;
		height: 15vh;
		font-size: 12px;
	}

	@media (max-width: ${({ theme }) => theme.breakpoints.xs}) {
		height: 15vh;
		font-size: 11px;
	}
`;

export const StyledTelNumber = styled.div`
	cursor: pointer;
	&:hover {
		background-color: ${({ theme }) => theme.colors.primaryLight};
	}
`;
export const StyledBlockModal = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
	.react-datepicker__month-container {
		float: left;
	}
`;
